const buttonElement = document.querySelector('button[data-action="toggle-color-scheme"]');

if (buttonElement) {
  const defaultText = buttonElement.textContent;

  const setColorScheme = (scheme, save = true) => {
    document.documentElement.dataset.colorScheme = scheme;
    if (save === true) {
      localStorage.setItem('color-scheme', scheme);
    }
    if (scheme === 'dark') {
      buttonElement.querySelector('span').textContent = 'Tagmodus';
    } else {
      buttonElement.querySelector('span').textContent = defaultText;
    }
  }


  buttonElement?.addEventListener('click', () => {
    if (document.documentElement.dataset.colorScheme === 'dark') {
      setColorScheme('light');
    } else {
      setColorScheme('dark');
    }
  });

  if (localStorage.getItem('color-scheme')) {
    setColorScheme(localStorage.getItem('color-scheme'));
  } else if (matchMedia('(prefers-color-scheme: dark)').matches) {
    setColorScheme('dark', false);
  }
}
